export default __webpack_public_path__ + "static/media/PERUBIKE-13.9edf7304.9edf7304.jpg";